<template>
  <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
    <section slot="desCountyName">
      <el-input
        style="width: 240px;"
        :value="`${desProvinceName} / ${desCityName} / ${desCountyName}`"
        readonly
      ></el-input>
    </section>
    <span
      slot="superzoneFeeTip"
      style="margin-left: 16px;"
      class="primary cur"
      @click="deleteItem"
    >删除</span>
  </qx-custom-form>
</template>

<script>
export default {
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    resultVal: {
      default: '',
    },
    index: {
      type: Number,
      default: 0,
    },
    cclaId: {
      type: Number,
      default: 0,
    },
    lineId: {
      type: Number,
      default: 0,
    },
    desProvince: {
      type: Number,
      default: 0,
    },
    desProvinceName: {
      type: String,
      default: '',
    },
    desCity: {
      type: Number,
      default: 0,
    },
    desCityName: {
      type: String,
      default: '',
    },
    desCounty: {
      type: Number,
      default: 0,
    },
    desCountyName: {
      type: String,
      default: '',
    },
    superzoneFee: {
      type: String,
    },
  },
  watch: {
    index: {
      immediate: true,
      handler (newValue) {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'label',
          value: '超区区县' + (newValue + 1),
          names: ['desCountyName'],
        });
      },
    },
    superzoneFee: {
      immediate: true,
      handler (newValue) {
        this.$nextTick(() => {
          this.$refs.baseForm && this.$refs.baseForm.setVal('superzoneFee', newValue);
        });
      },
    },
  },
  data () {
    return {
      baseForm: {
        inline: true,
        form: [
          {
            label: '主键',
            value: 'cclaId',
            readonly: true,
            hide: true,
          },
          {
            label: '线路ID',
            value: 'lineId',
            readonly: true,
            hide: true,
          },
          {
            label: '目的省份ID',
            value: 'desProvince',
            readonly: true,
            hide: true,
          },
          {
            label: '目的城市ID',
            value: 'desCity',
            readonly: true,
            hide: true,
          },
          {
            label: '目的县区ID',
            value: 'desCounty',
            readonly: true,
            hide: true,
          },
          {
            label: '超区区县',
            value: 'desCountyName',
            slot: true,
          },
          {
            label: '超区费用',
            value: 'superzoneFee',
            type: 'input',
            placeholder: '请输入超区费用',
            unit: '元',
            onChange: () => {
              const superzoneFee = this.$refs.baseForm.getVal('superzoneFee');
              this.$emit('resultVal', superzoneFee);
              this.$emit('change', superzoneFee);
            },
          },
        ],
      },
    };
  },
  methods: {
    deleteItem () {
      this.$emit('handleDeleteItem', this.index);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
